import React from 'react';
import Select from 'react-select';

const DutyResolver = ({ pairs, dutyOptions, resolutions, onResolve, loading }) => {
  if (pairs.length === 0) {
    return null;
  }

  return (
    <section className="widget full-width form-table">
      <header>
        <h3>Resolve cashier for unmatched rows</h3>
        <div className="actions">
          <span className="migration-hint">
            The staff name in the file didn't match a duty on that date
            automatically. Pick the correct duty for each row below.
          </span>
        </div>
      </header>
      <main>
        {loading ? (
          <p className="migration-hint">Loading duties…</p>
        ) : (
          <div className="form-content">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Staff (as in file)</th>
                  <th>Rows affected</th>
                  <th>Assign duty</th>
                </tr>
              </thead>
              <tbody>
                {pairs.map((pair) => {
                  const key = pair.key;
                  const options = dutyOptions[pair.date] || [];
                  return (
                    <tr key={key}>
                      <td>{pair.date}</td>
                      <td>{pair.staff}</td>
                      <td>{pair.count}</td>
                      <td>
                        <div className="input-wrapper w-130">
                          <Select
                            options={options}
                            className="select-box-container"
                            classNamePrefix="duty-resolver"
                            placeholder={
                              options.length === 0
                                ? 'No duties for this date'
                                : 'Select duty'
                            }
                            isDisabled={options.length === 0}
                            value={options
                              .flatMap((group) => group.options || [group])
                              .filter(
                                ({ value }) => value === resolutions[key],
                              )}
                            onChange={(option) =>
                              onResolve(key, option ? option.value : '')
                            }
                            menuPortalTarget={document.body}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </section>
  );
};

export { DutyResolver };
